/**
 * 这个文件作为组件的目录
 * 目的是统一管理对外输出的组件，方便分类
 */
/**
 * 布局组件
 */
import DutyButton from './RightContent/DutyButton';
import NoticeBell from './RightContent/NoticeBell';
import Footer from './Footer';
import { Question, SelectLang } from './RightContent';
import { AvatarDropdown, AvatarName } from './RightContent/AvatarDropdown';

export { AvatarDropdown, AvatarName, DutyButton, Footer, NoticeBell, Question, SelectLang };
